var Bookmarks, BookmarksPopupView, BookmarksView, Chaplin, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/bookmarks-popup');

View = require('views/base/view');

Bookmarks = require('models/bookmarks');

BookmarksView = require('views/bookmarks-view');

Chaplin = require('chaplin');

module.exports = BookmarksPopupView = (function(_super) {
  __extends(BookmarksPopupView, _super);

  function BookmarksPopupView() {
    _ref = BookmarksPopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  BookmarksPopupView.prototype.template = template;

  BookmarksPopupView.prototype.className = 'popup wide';

  BookmarksPopupView.prototype.tagName = 'div';

  BookmarksPopupView.prototype.id = 'bookmarks-popup';

  BookmarksPopupView.prototype.autoRender = true;

  BookmarksPopupView.prototype.container = 'body';

  BookmarksPopupView.prototype.regions = {
    '#bookmarks-container': 'bookmarks'
  };

  BookmarksPopupView.prototype.events = {
    'click .btn-close': 'closePopup',
    'click #btn-create-bookmark-section': 'showCreateSection',
    'click #btn-save-bookmark-section': 'showSaveSection',
    'click #btn-load-bookmark-section': 'showLoadSection',
    'click .btn-go-back': 'showManageSection',
    'submit #load-section-credentials': 'loadBookmarks',
    'submit #create-section-credentials': 'createBookmark',
    'submit #save-section-credentials': 'saveBookmarks'
  };

  BookmarksPopupView.prototype.listen = {
    'catalogue:bookmarksManage mediator': 'showManageSection',
    'catalogue:bookmarksLoad mediator': 'showLoadSection',
    'catalogue:bookmarksNew mediator': 'showCreateSection',
    'catalogue:bookmarksSave mediator': 'showSaveSection',
    'bookmarks:loadStarted collection': 'showLoader',
    'bookmarks:loadCompleted collection': 'loadCompleted',
    'bookmarks:loadFailed collection': 'loadFailed',
    'bookmarks:saveStarted collection': 'showLoader',
    'bookmarks:saveCompleted collection': 'saveCompleted'
  };

  BookmarksPopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  BookmarksPopupView.prototype.initialize = function() {
    BookmarksPopupView.__super__.initialize.apply(this, arguments);
    if (Chaplin.mediator.bookmarks === null) {
      Chaplin.mediator.bookmarks = new Bookmarks();
    }
    return this.collection = Chaplin.mediator.bookmarks;
  };

  BookmarksPopupView.prototype.render = function() {
    BookmarksPopupView.__super__.render.apply(this, arguments);
    return this.addBookmarksBlock('bookmarks', this.collection);
  };

  BookmarksPopupView.prototype.addCollectionListeners = function() {};

  BookmarksPopupView.prototype.addBookmarksBlock = function(region, collection) {
    var bookmarksSubView;
    bookmarksSubView = new BookmarksView({
      region: region,
      collection: collection
    });
    return this.subview('bookmarks', bookmarksSubView);
  };

  BookmarksPopupView.prototype.showManageSection = function() {
    this.$('.section').hide();
    return this.$('#manage-section').show();
  };

  BookmarksPopupView.prototype.showLoadSection = function() {
    this.$('.section').hide();
    return this.$('#load-section').show();
  };

  BookmarksPopupView.prototype.showCreateSection = function() {
    this.$('.section').hide();
    return this.$('#create-section').show();
  };

  BookmarksPopupView.prototype.showSaveSection = function() {
    this.$('.section').hide();
    return this.$('#save-section').show();
  };

  BookmarksPopupView.prototype.createBookmark = function(event) {
    var formData,
      _this = this;
    formData = $(event.currentTarget).serializeObject();
    this.publishEvent('catalogue:getActivePage', function(activePage) {
      _this.collection.create({
        page_num: activePage[0] || activePage[1],
        text: formData != null ? formData.text : void 0
      });
      _this.showManageSection();
      return event.currentTarget.reset();
    });
    return false;
  };

  BookmarksPopupView.prototype.saveBookmarks = function(event) {
    var formData;
    formData = $(event.currentTarget).serializeObject();
    this.collection.save(Chaplin.mediator.catalogue.get('id'), formData != null ? formData.email : void 0, formData != null ? formData.password : void 0);
    event.currentTarget.reset();
    return false;
  };

  BookmarksPopupView.prototype.saveCompleted = function() {
    this.hideLoader();
    alert('Your bookmarks successfully saved');
    return this.showManageSection();
  };

  BookmarksPopupView.prototype.loadBookmarks = function(event) {
    var formData;
    formData = $(event.currentTarget).serializeObject();
    this.collection.fetch(Chaplin.mediator.catalogue.get('id'), formData != null ? formData.email : void 0, formData != null ? formData.password : void 0);
    event.currentTarget.reset();
    return false;
  };

  BookmarksPopupView.prototype.loadCompleted = function() {
    this.hideLoader();
    return this.showManageSection();
  };

  BookmarksPopupView.prototype.loadFailed = function(error) {
    alert(error.error);
    return this.hideLoader();
  };

  BookmarksPopupView.prototype.showLoader = function() {
    return this.$('.loading').show();
  };

  BookmarksPopupView.prototype.hideLoader = function() {
    return this.$('.loading').hide();
  };

  return BookmarksPopupView;

})(View);
